import React from 'react'
import './picture.scss'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Expaned, Row } from '@/components/layout/layout'
import { useRequest } from 'ahooks'
import { IMaterials, MaterialsList } from '../../goods-manage/components/material-library/choose-material-dialog'
import { IPagination } from '@/model/types/common'
import { $post } from '@/api'
import Table, { ColumnsType } from 'antd/lib/table'
import { getVideoPreviewUrl } from '@/config/qiniu'
import WordHighLight from '@/components/word-highlight/word-highlight'
import { getFilesSizeMax } from '@/utils'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import RemarkPopover from '../../goods-manage/components/remark-popover/remark-popover'
import $msg from '@/utils/message'
import { materialStore } from '../store'
import { observer } from 'mobx-react'
import { showLayer } from '@/utils/layer'
import VideoPreview from '../../mall-manage/mall-shelf/goods-shelf/modules/goods-detail/modules/media-edit/video-preivew'

const formatDuration = (duration: number) => {
    const second = duration % 60
    const minute = Math.floor(duration / 60)

    const addZero = (num: number) => (num < 10 ? `0${num}` : num)

    return addZero(minute) + ':' + addZero(second)
}

export const materialColumns: ColumnsType<IMaterials> = [
    {
        title: '#',
        width: '50px',
        align: 'center',
        key: '2',
        render: (text, record, index) => {
            return <span>{index + 1}</span>
        },
    },
    {
        title: '视频',
        key: 'url',
        dataIndex: 'url',
        width: '70px',
        align: 'center',
        render: (text, record) => (
            <div
                data-position-relative
                data-cursor-pointer
                onClick={() => {
                    showLayer(<VideoPreview url={record.url} />)
                }}
            >
                <i className={`iconfont picture-material__play-icon iconshipin`} />
                <img
                    data-border-radius-5
                    data-margin-top-5
                    src={getVideoPreviewUrl(text)}
                    alt=""
                    data-width-50
                    data-height-50
                />
            </div>
        ),
    },
    {
        title: '视频名称',
        key: 'name',
        dataIndex: 'name',
        render: text => <WordHighLight keyword={materialStore.keyWord} word={text}></WordHighLight>,
    },
    {
        title: '时长',
        align: 'right',
        dataIndex: 'duration',
        sorter: (a, b) => (a.duration || 0) - (b.duration || 0),
        render: (v, r) => <span>{r.duration ? formatDuration(r.duration) : '未知'}</span>,
    },
    {
        title: '视频大小',
        align: 'right',
        key: 'size',
        dataIndex: 'size',
        sorter: (a, b) => a.size - b.size,
        render: text => <span>{getFilesSizeMax(text)}</span>,
    },
    {
        title: '播放次数',
        align: 'right',
        key: 'record',
        dataIndex: 'play_count',
        sorter: (a, b) => (a.play_count || 0) - (b.play_count || 0),
        render: (v, r) => <span>{r.play_count || 0}次</span>,
    },
]

const Videomaterial = observer(() => {
    const cls = useBemClass('picture-material')

    const columns: ColumnsType<IMaterials> = [
        {
            title: '操作',
            key: 'action',
            width: 124,
            align: 'center',
            render: (value, record) => (
                <Row data-width-100p data-center>
                    <RemarkPopover
                        placeholder="请输入名称"
                        value={record.name}
                        maxLen={15}
                        onConfirm={e => {
                            $post({
                                url: '/material/updatematerial',
                                params: {
                                    group_id: record.group.id,
                                    material_id: record.id,
                                    name: e,
                                },
                            }).then(() => {
                                $msg('success', '更改成功')
                                materialStore.setMaterialStatus()
                            })
                        }}
                    >
                        <div className="action">重命名</div>
                    </RemarkPopover>
                    <div
                        data-margin-left-14
                        className="action"
                        onClick={() => {
                            $post({
                                url: '/material/deletematerial',
                                params: {
                                    material_ids: [record.id],
                                },
                            }).then(() => {
                                $msg('success', '删除成功')
                                materialStore.setMaterialStatus()
                            })
                        }}
                    >
                        删除
                    </div>
                </Row>
            ),
        },
    ]

    const requestHandle = useRequest<
        MaterialsList,
        {
            materials: IMaterials[]
            pagination: IPagination
        }
    >(
        val =>
            $post({
                url: '/material/getmaterials',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    status: 1,
                    types: [2],
                    keyword: materialStore.keyWord || void 0,
                },
            }),
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.materials,
                    pagination: data.pagination,
                }
            },
            refreshDeps: [materialStore.keyWord, materialStore.materialStatus],
        },
    )

    return (
        <Expaned className={cls()}>
            <Expaned data-row className={cls('content')}>
                <AutoResizer>
                    {({ height }) => {
                        return (
                            <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                                <Table
                                    rowKey={record => record.id}
                                    loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                    bordered
                                    pagination={false}
                                    columns={[...materialColumns, ...columns]}
                                    dataSource={requestHandle.data?.list}
                                    scroll={{ x: 'max-content', y: height - 50 }}
                                />
                            </WithScrollLoad>
                        )
                    }}
                </AutoResizer>
            </Expaned>
        </Expaned>
    )
})

export default Videomaterial
